var React = require('react');

function MyProfileCardIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"20","height":"20","style":{"fill":"none"},"key":0}),React.createElement("g",{"id":"credit-card","key":1},[React.createElement("circle",{"id":"Ellipse_2885","cx":"5.2","cy":"12.5","r":"1.1","style":{"fill":"#5b6070"},"key":0}),React.createElement("path",{"id":"Path_7000","d":"M15.4,3H4.6c-2.1,0-3.9,1.7-3.9,3.9v6.2c0,2.1,1.7,3.9,3.9,3.9h10.8c2.1,0,3.9-1.7,3.9-3.9v-6.2c0-2.1-1.7-3.9-3.9-3.9ZM4.6,4.6h10.8c1.3,0,2.3,1,2.3,2.3H2.3c0-1.3,1-2.3,2.3-2.3ZM15.4,15.4H4.6c-1.3,0-2.3-1-2.3-2.3h0v-4.6h15.5v4.6c0,1.3-1,2.3-2.3,2.3h0Z","style":{"fill":"#5b6070"},"key":1})])]);
}

MyProfileCardIcon.defaultProps = {"id":"Layer_1","width":"20","height":"20","version":"1.1","viewBox":"0 0 20 20"};

module.exports = MyProfileCardIcon;

MyProfileCardIcon.default = MyProfileCardIcon;
